var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkyLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 231,
    viewBox: "0 0 614 231",
    fill: "#F4F7F8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197 0H249V17H282V219H328V39H418V104H430V80H454V104H479V80L543 101.318V166H577V219H614V231H577H543H528H500H479H454H430H418H394H328H282H249H205H197H182H133H129H112H102H54H36H0V219H36V193H54V158H102V193H112V127V101C112 89.402 121.402 80 133 80C144.598 80 154 89.402 154 101V127H182V17H197V0Z",
    fill: "#F4F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyLine);
export default __webpack_public_path__ + "static/media/skyLine.5792d5f70aed3a3a0ad7b5e8561637de.svg";
export { ForwardRef as ReactComponent };